import { useTranslate } from 'react-admin';
import globalUseStyles from '../../../styles/globalCustomStyles';
import { reverse_if_demo } from '../../../utils/anonymize';
import CardWrapper from '../../aegeon/cards/CardWrapper';

export default function CardAnalysis() {
  const globalClasses = globalUseStyles();
  const t = useTranslate();

  return (
    <CardWrapper resource="devices" type="analyse" unclickable={reverse_if_demo(false)}>
      <div className={globalClasses.cardCenter}>
        <img src='AEGEON_ICONES_NIV2-SIMPLE_PERFORMANCE.svg' alt="some file" height='150' width='150' />
      </div>
    </CardWrapper>

  );
}